import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })

};
const headers = new HttpHeaders().set("Content-Type", "application/json");

@Injectable()
export class CreatePickUpService {

    constructor(@Inject(HttpClient) private httpclient: HttpClient) {

    }

    createPickUp(apiurl, request: any): Observable<any> {
        let _body = JSON.stringify(request);
        let url = apiurl;
        return this.httpclient.post<any>(url, _body, httpOptions);
    }
}